import { Button } from '@ntconsult/aluma-react';
import { Tags } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type BatchTagsBarProps = {
  count: number;
  onManageTags: () => void;
  onClear: () => void;
};

export function BatchTagsBar({ count, onManageTags, onClear }: BatchTagsBarProps) {
  const { t } = useTranslation('alocacao');

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-border bg-muted px-4 py-2">
      <span className="text-sm font-medium text-foreground" aria-live="polite">
        {t('lote.selecionados', { count })}
      </span>
      <Button size="sm" variant="primary" leftIcon={<Tags size={14} />} onClick={onManageTags}>
        {t('lote.gerenciarTags')}
      </Button>
      <Button size="sm" variant="ghost" onClick={onClear}>
        {t('lote.limparSelecao')}
      </Button>
    </div>
  );
}
